// extracted by mini-css-extract-plugin
export default {"iconDefault":"t1TXe"};